import { useEffect, useState } from "react";

export function useIsMobileView(width: number = 768,height: number = 480) {
  const [ isMobile, setIsMobile ] = useState(false);

  useEffect(() => {
    const isMobileWidth = window.matchMedia(`
      only screen and (max-device-width: ${width}px) and (orientation: portrait) ,
      only screen and (max-device-height: ${height}px) and (orientation: landscape),
      only screen and (max-device-width: ${height}px) and (orientation: landscape)
    `);

    setIsMobile(isMobileWidth.matches);

    const listener = (ev: MediaQueryListEvent) => {
      setIsMobile(ev.matches);
    };

    isMobileWidth.addEventListener("change", listener);
    return () => {
      isMobileWidth.removeEventListener("change", listener);
    };
  }, [ width, height ]);

  return isMobile;
}